import React from 'react';
import { func, string } from 'prop-types';
import moment from 'moment-timezone';
import { useTimeMangementState } from '../TimeMangementStateProvider';

// import { Button } from 'reactstrap';
import { AuthHeader } from 'css/components/Modules/Headings';
import { PrimaryButton } from 'css/components/Modules/Buttons';
import { LoginForm } from 'css/components/Modules/login';

import getTimeObject from 'helpers/getTimeObject';
import useInput from 'custom_hooks/useInput';
function EventStart({ label, getEventDetails }) {
  const [
    {
      employeeLoginInfo: { FirstName, LastName }
    }
  ] = useTimeMangementState();

  const [inputValue, setInput] = useInput('');
  return (
    <LoginForm>
      <div className='event-start login-form-container'>
        <div className='text-center'>
          <AuthHeader>{label}</AuthHeader>
        </div>
        <div className='form-group'>
          <label>{label} Date*</label>
          <input readOnly value={moment().format('MM/DD/YY')} disabled={true} />
        </div>
        <div className='form-group clock-wrapper'>
          <label>{label} Time*</label>

          <input readOnly value={moment().format('hh:mm A')} disabled={true} />
        </div>
        <div className='form-group clock-wrapper'>
          <label>Memo</label>
          <input
            value={inputValue}
            type='text'
            onChange={setInput}
            placeholder='Add a memo (upto 100 characters)'
            maxLength={100}
          />
        </div>
        <div className='form-group'>
          <label className='mb-2'>Employee Name</label>
          <p>
            {FirstName} {LastName}
          </p>
        </div>
        <div className='text-center mt-auto mt-md-5 event-start__button'>
          <PrimaryButton
            onClick={() => {
              const { hours, minutes } = getTimeObject(moment().format('hh:mm A'));
              const date = moment().startOf('day').add({ hours, minutes }).utc().format();
              getEventDetails({ date, memo: inputValue });
            }}
          >
            Confirm
          </PrimaryButton>
        </div>
      </div>
    </LoginForm>
  );
}

EventStart.propTypes = {
  label: string.isRequired,
  getEventDetails: func.isRequired
};

export default EventStart;
